import { render, staticRenderFns } from "./CustomerTabPersonalData.vue?vue&type=template&id=011b9e82&scoped=true"
import script from "./CustomerTabPersonalData.vue?vue&type=script&lang=ts"
export * from "./CustomerTabPersonalData.vue?vue&type=script&lang=ts"
import style0 from "./CustomerTabPersonalData.vue?vue&type=style&index=0&id=011b9e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b9e82",
  null
  
)

export default component.exports